import { type Control, Controller, type FieldValues, type Path } from "react-hook-form";
import { InputWrapper } from "../form/input-wrapper";
import { useTranslation } from "../localization";
import { Weekdays } from "./weekdays";

/** Props Interface */
interface WeekdayPickerProps<T extends FieldValues> {
	control: Control<T>;
	name: Path<T>;
	disabledDays?: number[];
}

export function WeekdayPicker<T extends FieldValues>({
	control,
	name,
	disabledDays,
}: WeekdayPickerProps<T>) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<Controller
			control={control}
			name={name}
			render={({ field, formState }) => (
				<InputWrapper
					label={t("dates.weekdays")}
					name={name}
					errors={formState.errors}
					isRequired
					errorVariant="tooltip"
				>
					<Weekdays
						selectedDays={field.value || []}
						disabledDays={disabledDays || []}
						onSelectionChange={field.onChange}
						isReadonly={false}
					/>
				</InputWrapper>
			)}
		/>
	);
}
